<template>
    <div class="shop::admin-products-index">

        <div class="bg-[#fafafa] border flex gap-4 py-3 rounded-t-xl text-[#737373] text-xs uppercase">
            <div class="w-full lg:w-1/4 px-4">
                Filtering
            </div>


            <div class="w-full lg:w-3/4 px-4">
                Content
            </div>
        </div>

        <div class="bg-white border-l border-r border-b rounded-b-xl flex gap-4 px-4 py-6 text-sm">

            <div class="w-full lg:w-1/4">
                <div class="flex flex-col items-start">
                    <div class="font-bold mb-1">
                        Weergave
                    </div>
                    <div v-for="(label, view) in views" :class="{
                        'cursor-pointer': true,
                        'text-indigo-400': view === currentView
                    }" v-on:click="currentView = view">
                        {{ label }}
                    </div>
                </div>

<!--                TODO Medium: Create based on shop attributes, not hardcoded-->
                <div class="viewResult flex flex-col gap-4 mt-4">

                    <div class="flex flex-col items-start" v-if="currentView === 'attributes'">
                        <div class="font-bold mb-1">
                            Type
                        </div>

                        <div v-for="propertyValue in ['Bronze', 'Metaal']" class="cursor-pointer"
                            v-on:click="setViewActive('attributes', 'type', propertyValue)"
                             :class="{
                                'text-indigo-400': checkViewActive('attributes', 'type', propertyValue) || false,
                             }"
                        >
                            {{ propertyValue }}
                        </div>
                    </div>

                </div>
            </div>

            <div class="w-full lg:w-3/4 pr-4">

                <div class="flex gap-2 mb-4 text-base">
                    <div class="flex ml-auto mr-4 relative rounded-r-md">
                        <input type="search" class="border-gray-300 w-48 h-8 rounded-l-md pl-4 pr-12 py-1" v-model="search">
                        <div class="bg-gray-50 rounded-r-md px-2">
                            <i class="fas fa-search mr-2"></i>
                        </div>
                    </div>

                    <div class="cursor-pointer hover:bg-indigo-400 hover:text-white px-2.5 py-1 rounded-md"
                        :class="{
                            'bg-indigo-400 text-white': productListing === 'list',
                            'bg-gray-50': productListing !== 'list'
                        }"
                         v-on:click="productListing = 'list'"
                    >
                        <i class="fas fa-list"></i>
                    </div>

                    <div class="cursor-pointer hover:bg-indigo-400 hover:text-white px-2.5 py-1 rounded-md"
                        :class="{
                            'bg-indigo-400 text-white': productListing === 'grid',
                            'bg-gray-50': productListing !== 'grid'
                        }"
                         v-on:click="productListing = 'grid'"
                    >
                        <i class="fas fa-grid"></i>
                    </div>
                </div>

                <div :class="{
                    'gap-8 grid lg:grid-cols-3': productListing === 'grid',
                    'gap-4 flex flex-col': productListing === 'list',
                }">
                    <div v-for="product in productsConcept" class="relative flex group item" :class="{
                        'flex-col': productListing === 'grid',
                        'px-4 py-3 rounded-xl': productListing === 'list',
                        'bg-gray-50': productListing === 'list' && Object.keys(viewActive).length,
                        'bg-green-50 rounded-xl': ['attributes', 'filters'].includes(currentView)
                            && checkProductCurrentViewActive(product, true),
                        'bg-red-50 rounded-xl': ['attributes', 'filters'].includes(currentView)
                            && checkProductCurrentViewActive(product, false),
                    }" v-on:click="setProductPropertyBasedOnViewActive(product)">
                        <div class="image aspect-[1] rounded-lg relative overflow-hidden"
                            :class="{
                                'w-20': productListing === 'list'
                            }"
                        >
                            <img class="absolute inset-0 object-cover h-full w-full transition"
                                 src="/img/website/placeholder.png"
                                 alt="Product image"
                                 loading="lazy"
                                 :class="{
                                    'opacity-25': currentView !== 'default',
                                }"
                            />

                            <div class="absolute bg-indigo-400 flex aspect-[1] items-center justify-center left-0 ml-2 mt-2 rounded-full text-white top-0"
                                 :class="{
                                    'w-7': productListing === 'grid',
                                    'w-6 text-sm': productListing === 'list',
                                 }"
                                 v-if="Object.keys(checkDifferenceProductConcept(product)).length"
                            >
                                <i class="fas fa-floppy-disk"></i>
                            </div>

                            <div class="absolute right-0 bottom-0 pr-2 pb-2 translate-y-full group-hover:translate-y-0 transition pointer-events-none group-hover:pointer-events-auto"
                                v-if="productListing === 'grid'"
                            >
                                <a class="bg-orange-400 hover:bg-orange-500 text-white h-7 w-7 flex items-center justify-center text-sm rounded-full"
                                   :href="product.slug"
                                >
                                    <i class="fas fa-pencil"></i>
                                </a>
                            </div>
                        </div>

                        <div class="absolute grid place-items-center z-10"
                            :class="{
                                'left-0 ml-24 pl-2 h-full top-0': productListing === 'list',
                                'aspect-[1] w-full': productListing === 'grid',
                                'pointer-events-none': currentView !== 'price',
                            }"
                        >

                            <div class="flex items-center gap-2 text-gray-700" v-show="currentView === 'price'"
                                :class="{
                                    'mt-auto pb-4': productListing === 'list'
                                }"
                            >
                                <span :class="{
                                    'text-lg': productListing === 'grid',
                                }">€</span>

                                <input name="price"
                                       v-model="product.price"
                                       class="bg-transparent border-b border-black outline-none w-32"
                                       :class="{
                                           'text-2xl text-center': productListing === 'grid',
                                       }"
                                />
                            </div>

                        </div>

                        <div class="flex-1 mt-2 pl-2 pr-4 transition"
                             :class="{
                                    'opacity-25': currentView !== 'default',
                                }"
                        >
                            <div class="brand truncate text-xs text-gray-400">
                                {{ product.brand.name }}
                            </div>

                            <div class="title mt-1">
                                {{ product.name }}
                            </div>

                            <div class="price mt-1" :class="{
                                'text-indigo-400': checkDifferenceProductConcept(product).price || false,
                                'opacity-0 pointer-events-none': productListing === 'list' && currentView === 'price'
                            }">
                                € {{ product.price }}
                            </div>
                        </div>

                        <div class="ml-auto pl-4 flex flex-col justify-center" v-if="productListing === 'list'">
                            <a class="bg-orange-400 hover:bg-orange-500 text-white h-7 w-7 flex items-center justify-center text-sm rounded-full"
                               :href="product.slug"
                            >
                                <i class="fas fa-pencil"></i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            search: '',
            productListing: 'grid',

            views: {
                'default': 'Standaard',
                'price': 'Prijs',
                'attributes': 'Attributes',
                'filters': 'Filters'
            },
            currentView: 'default',
            viewActive: {
                type: null,
                property: null,
                value: null,
            },

            filters: {
                'is_simple': false,
                'price': false,
                'is_featured': false,
                'has_sale': false,
                'check_stock': false,
                'stock_amount': false,
                'is_in_stock': false,
                'brand': false,
                'category': false,
                'attributes': false,
                'filters': false,
                'vat': false,
                'published': false,
                'show_variants': false,
            },

            products: [
                {
                    id: 1,
                    name: 'Test',
                    slug: 'test',
                    brand: {
                        id: 1,
                        name: 'Overig',
                    },
                    price: '40',
                    attributes: {
                        type: 'Metaal',
                    }
                },
                {
                    id: 2,
                    name: 'Organisch Gebreide Vest',
                    slug: 'organisch-gebreide-vest',
                    brand: {
                        id: 1,
                        name: 'Overig',
                    },
                    price: '40',
                    attributes: {
                        type: 'Bronze',
                    }
                },
                {
                    id: 3,
                    name: 'Donkere spijkerbroek',
                    slug: 'donkere-spijkerbroek',
                    brand: {
                        id: 1,
                        name: 'Overig',
                    },
                    price: '40',
                    attributes: {
                    }
                }
            ],

            // TODO Medium: This will be saved automatically after changes (in concept tables)
            productsConcept: []
        }
    },

    mounted() {
        this.productsConcept = JSON.parse(JSON.stringify(this.products));
    },

    methods: {

        // Set attribute or filter as active (for example: viewActive.attributes.type = 'Metal')
        setViewActive(type, property, value)
        {
            // Reset other options
            this.viewActive = {
                type: type,
                property: property,
                value: value,
            };
        },

        checkViewActive(type, property, value)
        {
            return this.viewActive.type === type
                && this.viewActive.property === property
                && this.viewActive.value === value;
        },

        checkProductCurrentViewActive(product, active)
        {
            if( !this.viewActive.type || !product[this.viewActive.type] ) {
                return !active;
            }

            if( active ) {
                return product[this.viewActive.type][this.viewActive.property] === this.viewActive.value;
            }

            return product[this.viewActive.type][this.viewActive.property] !== this.viewActive.value;
        },

        setProductPropertyBasedOnViewActive(product)
        {
            if( !this.viewActive.type ) {
                return false;
            }

            this.$set(product[this.viewActive.type], this.viewActive.property, this.viewActive.value);
        },

        checkDifferenceProductConcept(product)
        {
            let originalProduct = this.products.find((originalProduct) => originalProduct.id === product.id);

            return this.diffObjects(product, originalProduct);
        },

        diffObjects(obj1, obj2) {
            const diff = {};
            for (const key in obj1) {
                if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
                    if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                        const nestedDiff = this.diffObjects(obj1[key], obj2[key]);
                        if (Object.keys(nestedDiff).length > 0) {
                            diff[key] = nestedDiff;
                        }
                    } else if (obj1[key] !== obj2[key]) {
                        diff[key] = [obj1[key], obj2[key]];
                    }
                } else {
                    diff[key] = [obj1[key], undefined];
                }
            }
            for (const key in obj2) {
                if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
                    diff[key] = [undefined, obj2[key]];
                }
            }
            return diff;
        }

    }
}
</script>
